export default "__VITE_ASSET__mGShdrz0__"